<!-- 李丁 -->
<template>
  <div>
    <div id="app">
      <navbar></navbar>
      <router-view></router-view>
      <login v-if="showLogin" :showLogin='showLogin' @close='closeLogin'></login>
      <Examination v-if="showExamination" :showExamination='showExamination' @close='closeExamination'></Examination>
    </div>
    <SDAUfooter></SDAUfooter>
  </div>
</template>
<script>
export default {
  name: 'App',
  data() {
    return {
      showLogin: false,
      showExamination: false
    }
  },
  methods: {
    closeLogin() {
      this.showLogin = false
    },
    closeExamination() {
      window.localStorage.setItem('Examination', false)
      this.showExamination = false
    },
    setappHeight() {
      // 高度不够仍把footer顶到底部 
      let app = document.getElementById("app")
      app.style.minHeight = "calc(" + document.documentElement.clientHeight + "px - 224px)";
      console.log(app.style.minHeight, 'lding');
    },
    admissionExaminationandLogin() {
      this.showExamination = window.localStorage.getItem('SDAU_token') ? JSON.parse(window.localStorage.getItem('Examination')) : false
      this.showLogin = window.localStorage.getItem('SDAU_token') ? false : true
    },
  },
  mounted() {
    this.admissionExaminationandLogin()
    // 在窗口改变时监听触发footer顶到底部事件并防抖每半秒才执行一次
    this.setappHeight()
    const fangdou = (fn, delay) => {
      let timer;
      return function () {
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(() => {
          fn();
        }, delay);
      }
    };
    const resetappHeight = fangdou(this.setappHeight, 500);
    window.addEventListener('resize', resetappHeight);
    // 登录全局组件触发
    this.$eventBus.$on('goLogin', (message) => {
      this.showLogin = message
    })
  }
}
</script>
<style lang="scss">
* {
  margin: 0;
  padding: 0;
}
</style>
